'use client';

import * as React from 'react';

const FlatUIContext = React.createContext(false);

/**
 * Renders the primitives below it without drop shadows, separating surfaces with borders instead (VelociFI's flat UI).
 * Context reaches through portals, so dialogs, popovers and menus opened inside go flat too.
 */
export const FlatUIProvider = ({ children }: { children: React.ReactNode }) => (
  <FlatUIContext.Provider value={true}>{children}</FlatUIContext.Provider>
);

export const useFlatUI = () => React.useContext(FlatUIContext);
